import Api from "../api/api";

export default async (body) => {
  const { data } = await Api.post("profile/business-update/description", body);
  return data;
};
